import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";

import { Plant } from "@models/Plant";

import { PlantsService } from "./plants.service";
import { SearchService } from "./search.service";

@Injectable()
export class PlantProfileResolver {
  constructor(
    private plantsService: PlantsService,
    private searchService: SearchService
  ) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<Plant> {
    this.searchService.updateSearchStatus(true);
    const symbol = route.paramMap.get("id");
    const searchName = route.queryParams["searchName"];

    if (searchName === "Family") {
      const plantSearchSymbol = await this.plantsService.getPlantBySymbolSearchName(
        symbol,
        searchName
      );
      return plantSearchSymbol;
    } else {
      const plantSymbol = await this.plantsService.getPlantBySymbol(symbol);
      return plantSymbol;
    }
  }
}
